import { push } from "Helpers/History";
import { store } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import { translatorf } from "Languages/Utility/translatorf";
import {
  logout,
  lockSystem,
  unlockSystem,
  getNotificationCount,
} from "Stores/actions";
import { GETAGAINNOTIFICATION } from "Stores/actionTypes";

export const analyzeActionCode = (data) => {
  return (dispatch) => {
    // LockSystem = 1,
    // UnLockSystem = 2,
    // SignOut = 3,
    // Ticket = 4,
    // Message = 5,
    // LockPayment = 6,
    // UnlockPayment = 7,
    switch (data) {
      case 1:
        store("isLocked", "FLSTMM");
        dispatch(lockSystem());
        break;
      case 2:
        store("isLocked", "UNFLSTMM");
        dispatch(unlockSystem());
        break;
      case 3:
        dispatch(logout());
        break;
      // case 4:
      //   dispatch(logout());
      //   break;
      case 5:
        showNotify({
          text: translatorf("newNotification"),
          pos: "top-left",
          customClass: "question",
          showAction: true,
          actionText: translatorf("notification"),
          onActionClick: () => {
            push("/dashboard/notifications");
          },
        });
        dispatch({
          type: GETAGAINNOTIFICATION,
          status: true,
        });
        dispatch(getNotificationCount());
        break;
      // case 6:
      //   dispatch(logout());
      //   break;
      // case 7:
      //   dispatch(logout());
      //   break;
      case 99:
        // window.location.href = window.location.href;
        window.location.reload();
        break;
      default:
        return;
    }
  };
};
